export const MODES = ['FTL', 'LTL', 'IMDL', 'DRAY', 'PTL', 'EXP', 'VLTL'] as const

export type Mode = typeof MODES[number]

export type FullMode =
  | 'less_than_truckload'
  | 'partial_truckload'
  | 'full_truck_load'
  | 'intermodal'
  | 'drayage'
  | 'EXP' //We are using the "short-name" here until we have a better source-of-truth in back-end
  | 'volume_less_than_truckload'
